import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { CheckLaborerHasReportResponse } from 'api/contractAuthAPI'

type State = {
  hasReport: boolean
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  hasReport: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CHECK_LABORER_HAS_REPORT_ASYNC,
    Actions.CHECK_LABORER_HAS_REPORT_SUCCESS,
    Actions.CHECK_LABORER_HAS_REPORT_FAIL,
    CheckLaborerHasReportResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CHECK_LABORER_HAS_REPORT_ASYNC:
    case Actions.CHECK_LABORER_HAS_REPORT_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.CHECK_LABORER_HAS_REPORT_SUCCESS: {
      return {
        ...state,
        ...action.status,
        hasReport: action.payload.has_run_away_reports,
      }
    }
    default:
      return state
  }
}
